import { defineMessages } from 'react-intl';

export const frameMessages = defineMessages({
	footer__powered_by: {
		id: 'frame.footer.powered_by',
		defaultMessage: 'Powered by',
		description: '"Powered by" text placed in chat footer near logo',
	},
});
